export const ERROR_MES_SET = "ERROR_MES_SET"
export const ERROR_MES_REMOVE = "ERROR_MES_REMOVE"

export const MOVIE_DETAIL_SET = "MOVIE_DETAIL_SET"
export const MOVIE_LATEST_SET = "MOVIE_LATEST_SET"
export const MOVIE_NOW_PLAYING_SET = "MOVIE_NOW_PLAYING_SET"
export const MOVIE_POPULAR_SET = "MOVIE_POPULAR_SET"
export const MOVIE_TOP_RATED_SET = "MOVIE_TOP_RATED_SET"
export const MOVIE_UPCOMING_SET = "MOVIE_UPCOMING_SET"
export const MOVIE_FAV_LIST_SET = "MOVIE_FAV_LIST_SET"
export const MOVIE_FAV_ITEM_ADD = "MOVIE_FAV_ITEM_ADD"
export const MOVIE_FAV_ITEM_REMOVE = "MOVIE_FAV_ITEM_REMOVE"

export const MOVIE_DETAIL_GET = "MOVIE_DETAIL_GET"
export const MOVIE_LATEST_GET = "MOVIE_LATEST_GET"
export const MOVIE_NOW_PLAYING_GET = "MOVIE_NOW_PLAYING_GET"
export const MOVIE_POPULAR_GET = "MOVIE_POPULAR_GET"
export const MOVIE_TOP_RATED_GET = "MOVIE_TOP_RATED_GET"
export const MOVIE_UPCOMING_GET = "MOVIE_UPCOMING_GET"
export const MOVIE_LIST_CREATE = "MOVIE_LIST_CREATE"
export const MOVIE_LIST_GET = "MOVIE_LIST_GET"
export const MOVIE_FAV_LIST_GET = "MOVIE_FAV_LIST_GET"

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_INITIATE_LOGOUT = 'AUTH_INITIATE_LOGOUT'
export const AUTH_CHECK_TIMEOUT = 'AUTH_CHECK_TIMEOUT'
export const AUTH_USER = 'AUTH_USER'
export const AUTH_CHECK_STATE = 'AUTH_CHECK_STATE';

export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';
export const SET_AUTH_LIST_ID = 'SET_AUTH_LIST_ID';
// export const GET_AUTH_LIST_ID = 'GET_AUTH_LIST_ID';
